/**
 * @description 获取页面的来源
 * @returns {string}
 */
export const addressBarFrom = (): string => document.referrer
